import { useEffect } from "react";

export function usePageMeta(meta) {
  useEffect(() => {
    // Set title
    if (meta?.title) {
      document.title = meta.title;
    }

    // Set or update meta tags
    const updateMetaTag = (name, content) => {
      let tag = document.querySelector(`meta[name="${name}"]`);
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute("name", name);
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", content);
    };

    // Set OG tags
    const updateOGTag = (property, content) => {
      let tag = document.querySelector(`meta[property="${property}"]`);
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute("property", property);
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", content);
    };

    // Set description
    if (meta?.description) {
      updateMetaTag("description", meta.description);
      updateOGTag("og:description", meta.description);
    }

    // Set keywords
    if (meta?.keywords) {
      updateMetaTag("keywords", meta.keywords);
    }

    // Set OG title
    if (meta?.title) {
      updateOGTag("og:title", meta.title);
    }

    // Set canonical URL
    if (meta?.canonical) {
      let canonical = document.querySelector("link[rel='canonical']");
      if (!canonical) {
        canonical = document.createElement("link");
        canonical.setAttribute("rel", "canonical");
        document.head.appendChild(canonical);
      }
      canonical.setAttribute("href", meta.canonical);
    }

    // Set Open Graph image if provided
    if (meta?.image) {
      updateOGTag("og:image", meta.image);
    }

    // Set viewport for mobile
    let viewport = document.querySelector("meta[name='viewport']");
    if (!viewport) {
      viewport = document.createElement("meta");
      viewport.setAttribute("name", "viewport");
      viewport.setAttribute("content", "width=device-width, initial-scale=1");
      document.head.appendChild(viewport);
    }
  }, [meta]);
}

export default usePageMeta;
